import { connect } from 'react-redux';
import KYCLevelsComponent from './KYCLevelsComponent';

const mapStateToProps = state => {
  return {
    userEmail: state.user?.userInfo?.Email
  };
};

const KYCLevelsContainer = connect(mapStateToProps)(KYCLevelsComponent);

export default KYCLevelsContainer;
